export default __webpack_public_path__ + "static/thumbnail-34c9beb8c22a46fc5b9075677dbcb67d.webp";